export const ALLOWANCE_CREDIT_PREFIX = "ea:";

export const creditLineAmount = (value) => {
    if (value && typeof value === "object") {
        const n = Number(value.amount ?? value.employee_share_monthly_amount ?? value.monthly_amount ?? 0);
        return Number.isFinite(n) ? n : 0;
    }
    const n = Number(value ?? 0);
    return Number.isFinite(n) ? n : 0;
};

export const creditLineLabel = (key, value) => {
    if (value && typeof value === "object" && value.label) {
        return String(value.label);
    }
    const keyStr = String(key || "");
    if (keyStr.startsWith(ALLOWANCE_CREDIT_PREFIX)) {
        return "Variable Allowance";
    }
    return keyStr;
};

export const mapCreditsBreakupToEditorRows = (breakup, meta) => {
    const entries = Object.entries(breakup || {});
    if (entries.length === 0) {
        return [{ key: "", name: "", amount: 0 }];
    }
    return entries.map(([key, value]) => ({
        key,
        name: creditLineLabel(key, value),
        amount: creditLineAmount(value),
        nameReadOnly: String(key).startsWith(ALLOWANCE_CREDIT_PREFIX),
        overridden: Boolean(meta?.[key]?.overridden),
        original_amount: meta?.[key]?.original_amount,
        out_of_sync: Boolean(meta?.[key]?.out_of_sync),
        assignment_amount: meta?.[key]?.assignment_amount,
    }));
};

export const creditsEditorRowsToBreakup = (rows) => {
    const obj = {};
    (rows || []).forEach((item) => {
        const amount = Number(item.amount);
        if (!Number.isFinite(amount) || amount === 0) {
            return;
        }
        const dictKey = item.key || item.name;
        if (!dictKey) {
            return;
        }
        if (String(dictKey).startsWith(ALLOWANCE_CREDIT_PREFIX)) {
            let assignmentId;
            const suffix = String(dictKey).slice(ALLOWANCE_CREDIT_PREFIX.length);
            if (/^\d+$/.test(suffix)) {
                assignmentId = parseInt(suffix, 10);
            }
            obj[dictKey] = {
                amount: Math.round(amount * 100) / 100,
                label: (item.name || "").trim() || creditLineLabel(dictKey, null),
                kind: "variable_allowance",
                ...(assignmentId ? { assignment_id: assignmentId } : {}),
            };
        } else if (item.name) {
            obj[item.name.trim()] = amount;
        }
    });
    return obj;
};

export const breakupEntriesForDisplay = (breakup) =>
    Object.entries(breakup || {})
        .filter(([, v]) => v !== null && v !== undefined && v !== "")
        .map(([key, value]) => ({
            key,
            label: creditLineLabel(key, value),
            amount: creditLineAmount(value),
        }));
